module.exports = __webpack_public_path__ + "static/media/issuer.b6ac60b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/issuer.svg
// module id = 528
// module chunks = 0